export default __webpack_public_path__ + "static/626-a026addf43f17aa0682fb0cda9a31a43.gif";